import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import fluencyLogo from '../../src/assets/preface-logo.png';
import { useAuth } from './AuthProvider';

// Auth protection wrapper component
const RequireAuth = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Show loading state
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <img src={fluencyLogo} alt="AFC" className="h-24 mx-auto mb-6" />
          <div className="flex items-center justify-center">
            <Loader2 className="animate-spin h-8 w-8 mr-2" style={{ color: '#2d6b78' }} />
            <span className="text-xl text-gray-600">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login while preserving the intended destination
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default RequireAuth;